import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Login from './views/Login.vue'
import AppLayout from './components/layout/AppLayout.vue'
import Dashboard from './views/Dashboard.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: {
        beforeRouteEnter(to, from, next) {
          // Verificar autenticación antes de determinar la redirección
          const isAuthenticated = store.getters['auth/isAuthenticated']
          const hasToken = store.getters['auth/token']
          
          if (isAuthenticated) {
            next('/dashboard')
          } else if (hasToken) {
            // Si hay token pero no está autenticado, el navigation guard se encargará
            next('/dashboard')
          } else {
            next('/login')
          }
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresGuest: true }
    },
    {
      path: '/dashboard',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: Dashboard
        }
      ]
    },
    {
      path: '/sensors',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Sensors',
          component: () => import('./views/Sensors.vue')
        }
      ]
    },
    {
      path: '/devices',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Devices',
          component: () => import('./views/Devices.vue')
        },
        {
          path: ':id',
          name: 'device-detail',
          component: () => import('./views/DeviceDetail.vue')
        }
      ]
    },
    {
      path: '/alerts',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Alerts',
          component: () => import('./views/Alerts.vue')
        }
      ]
    },
    {
      path: '/reports',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Reports',
          component: () => import('./views/Reports.vue')
        }
      ]
    },
    {
      path: '/settings',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Settings',
          component: () => import('./views/Settings.vue')
        }
      ]
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  // Check if user is authenticated
  let isAuthenticated = store.getters['auth/isAuthenticated']
  const hasToken = store.getters['auth/token']
  
  // If route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Si no está autenticado pero tiene token, intentar verificar la sesión
    if (!isAuthenticated && hasToken) {
      try {
        const authResult = await store.dispatch('auth/checkAuth')
        if (authResult) {
          isAuthenticated = true
          next()
        } else {
          // Token inválido, limpiar y redirigir a login
          await store.dispatch('auth/logout')
          next('/login')
        }
      } catch (error) {
        // Error al verificar token, limpiar y redirigir a login
        // Error verifying auth - handled silently
        await store.dispatch('auth/logout')
        next('/login')
      }
    } else if (!isAuthenticated && !hasToken) {
      // No hay token ni autenticación, redirigir a login
      next('/login')
    } else {
      // Usuario ya autenticado
      next()
    }
  }
  // If route requires guest (not authenticated)
  else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Si tiene token, verificar si sigue siendo válido
    if (hasToken && !isAuthenticated) {
      try {
        const authResult = await store.dispatch('auth/checkAuth')
        if (authResult) {
          next('/dashboard')
        } else {
          // Token inválido, limpiar y permitir acceso a página de invitado
          await store.dispatch('auth/logout')
          next()
        }
      } catch (error) {
        // Token inválido, limpiar y permitir acceso a página de invitado
        await store.dispatch('auth/logout')
        next()
      }
    } else if (isAuthenticated) {
      // Usuario autenticado, redirigir a dashboard
      next('/dashboard')
    } else {
      // Usuario no autenticado, permitir acceso a página de invitado
      next()
    }
  }
  // Default case
  else {
    next()
  }
})

export default router 


// WEBPACK FOOTER //
// ./src/router.js